export const SHOW_REGISTER_SUCCESS_PAGE = 'events/SHOW_REGISTER_SUCCESS_PAGE';

/**
 * @return {{type: object}}
 */
export const showRegisterSuccessPage = (show) => ({
  type: SHOW_REGISTER_SUCCESS_PAGE,
  payload: show,
});
